export const PRACTICE_CHARACTERIZATION_EVALUATION_VALUES = {
  SATISFIED: 'S',
  PARTIAL: 'P',
  DEFICIENT: 'D',
  UNAVAILABLE: 'N/A',
  NOT_SET: ''
};
